import { createFileRoute } from '@tanstack/react-router';
import { VersionsPage } from '@/components/versions/VersionsPage';

export const Route = createFileRoute('/sites/$siteSlug/versions')({ component: VersionsRoute });
function VersionsRoute() {
  const { siteSlug } = Route.useParams();
  return <VersionsPage key={siteSlug} siteSlug={siteSlug} />;
}
